import { render, staticRenderFns } from "./two_factor_authentication_page.vue?vue&type=template&id=63c1e69a"
import script from "./two_factor_authentication_page.vue?vue&type=script&lang=js"
export * from "./two_factor_authentication_page.vue?vue&type=script&lang=js"
import style0 from "./two_factor_authentication_page.vue?vue&type=style&index=0&id=63c1e69a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports